module.exports = __webpack_public_path__ + "media/images/bg/global-2042b6fdc04b130167f3a96b37b228c1.gif";